export const CommonQualificationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Qualifiche',
    path: '/sistema/qualifiche',
  },
];
